import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Link, createSearchParams } from 'react-router-dom';
import i18n from 'src/i18n';

import clockOutline from 'src/assets/courseDetail/clockOutline.png';
import clockPin from 'src/assets/courseDetail/clockPin.png';
import disk from 'src/assets/courseCard/disk.png';

import favIcon from 'src/assets/courseCard/favIcon.png';
import unfavIcon from 'src/assets/courseCard/unfavIcon.svg';

import withProfile from 'src/components/withProfile';
import PurchaseModal from './PurchaseModal';
import RatingImg from '../InfoSection/components/RatingImg';

import styles from './styles.module.scss';

@observer
class MainCard extends React.Component {
  render() {
    const { viewModel, profile, ratingCount, bread } = this.props;

    return (
      <>
        <div className={clsx(styles.mainCardContainer, styles.mainCardContainer_layout)}>
          <div className={clsx(styles.mainCard, styles.mainCard_layout)}>
            <div className={clsx(styles.cardContainer, styles.cardContainer_layout)}>
              <div className={clsx(styles.cardFlex, styles.cardFlex_layout)}>
                <h1 className={clsx(styles.courseTitle, styles.courseTitle_layout)}>
                  {viewModel.name ?? ' '}
                </h1>
                <h3 className={clsx(styles.courseSubtitle, styles.courseSubtitle_layout)}>
                  {viewModel.subtitle ?? ' '}
                </h3>
                <div className={clsx(styles.tagsFlex, styles.tagsFlex_layout)}>
                  <Link
                    to={{
                      pathname: `/list/${viewModel.lowerType}`,
                      search: `?${createSearchParams({ filter: viewModel.category?.id, sort: 'Date' })}`
                    }}
                    className={clsx(styles.categoryContainer, styles.categoryContainer_layout)}
                  >
                    <h5 className={clsx(styles.categoryText, styles.categoryText_layout)}>
                      {viewModel.category?.name ?? ' '}
                    </h5>
                  </Link>
                  <h5 className={clsx(styles.tagsContainer_box, styles.tagsContainer_box_layout)}>
                    <pre className={clsx(styles.tagsContainer)}>
                      {
                        viewModel.tags?.map((tag) => <span key={tag.id} className={styles.tag}>{`#${tag.name} `}</span>)
                      }
                    </pre>
                  </h5>
                </div>

                {
                  viewModel.discountRemain && (
                    <div className={clsx(styles.discountContainer, styles.discountContainer_layout)}>
                      <div className={clsx(styles.discountContainer_item)}>
                        <div style={{ '--src': `url(${clockOutline})` }} className={clsx(styles.clockIcon, styles.clockIcon_layout)}>
                          <div style={{ '--src': `url(${clockPin})` }} className={clsx(styles.pinIcon, styles.pinIcon_layout)} />
                        </div>
                      </div>
                      <h5 className={clsx(styles.discountText, styles.discountText_layout)}>
                        {viewModel.discountRemain ?? ' '}
                      </h5>
                    </div>
                  )
                }

                <div className={clsx(styles.priceContainer, styles.priceContainer_layout)}>
                  {
                    viewModel.discountRemain && (
                      <h5 className={clsx(styles.originPrice, styles.originPrice_layout)}>
                        {`${i18n.t('course_origin_price')}${viewModel.price ?? ''}${i18n.t('profile_my_point_left_unit')}` ?? ''}
                      </h5>
                    )
                  }
                  <h1 className={clsx(styles.finalPrice, styles.finalPrice_layout)}>
                    {`${viewModel.discountRemain ? viewModel.price - viewModel.discount.price : viewModel.price ?? '0'}${i18n.t('profile_my_point_left_unit')}`}
                  </h1>
                </div>

                <div className={clsx(styles.otherInfoRow, styles.otherInfoRow_layout)}>
                  <div />
                  <div className={clsx(styles.infoFlex_item)}>
                    {
                      ratingCount >= 10
                        ? (
                          <div
                            className={clsx(styles.scoreContainer, styles.scoreContainer_layout)}
                            onClick={viewModel.onRatingClick}
                          >
                            <h1 className={clsx(styles.scoreText, styles.scoreText_layout)}>
                              {viewModel.scoreText}
                            </h1>
                            <div className={clsx(styles.scoreStars, styles.scoreStars_layout)}>
                              <RatingImg stars={viewModel.roundRating} size={12} disabled />
                            </div>
                          </div>
                        )
                        : (
                          <div onClick={viewModel.onRatingClick}>
                            <h1 className={clsx(styles.scoreNot)}>
                              {i18n.t('rating_nobody_score_course_tiny')}
                            </h1>
                            <div className={clsx(styles.scoreStars, styles.scoreStars_layout)}>
                              <RatingImg stars={0} size={12} disabled />
                            </div>
                          </div>
                        )
                    }

                  </div>
                  <div className={clsx(styles.infoFlex_item1)}>
                    <div className={clsx(styles.box10, styles.box10_layout)} />
                  </div>
                  <div className={clsx(styles.infoFlex_item2)}>
                    <div className={clsx(styles.viewedContainer, styles.viewedContainer_layout)}>
                      <h1 className={clsx(styles.viewedText_box, styles.viewedText_box_layout)}>
                        {
                          viewModel.tenThousands
                            ? (
                              <div className={clsx(styles.viewedText)}>
                                <span className={clsx(styles.viewedText_span0)}>{`${viewModel.tenThousands.upper}.${viewModel.tenThousands.lower}`}</span>
                                <span className={clsx(styles.viewedText_span1)}>萬</span>
                              </div>
                            )
                            : (
                              <div className={clsx(styles.viewedText)}>
                                <span className={clsx(styles.viewedText_span0)}>{viewModel.popularity}</span>
                              </div>
                            )
                        }
                      </h1>
                      <div className={clsx(styles.viewedDescription, styles.viewedDescription_layout)}>
                        {i18n.t('course_info_viewed')}
                      </div>
                    </div>
                  </div>
                  <div className={clsx(styles.infoFlex_item3)}>
                    <div className={clsx(styles.box10, styles.box10_layout)} />
                  </div>
                  <div className={clsx(styles.infoFlex_item4)}>
                    <div className={clsx(styles.timeContainer, styles.timeContainer_layout)}>
                      <h1 className={clsx(styles.timeText_box, styles.timeText_box_layout)}>
                        {
                          viewModel.totalLength.hours
                            ? (
                              <div className={clsx(styles.timeText)}>
                                <span className={clsx(styles.timeText_span0)}>{viewModel.totalLength.hours}</span>
                                <span className={clsx(styles.timeText_span1)}>{i18n.t('learning_unit_hour')}</span>
                                <span className={clsx(styles.timeText_span2)}>{` ${viewModel.totalLength.minutes}`}</span>
                                <span className={clsx(styles.timeText_span3)}>{i18n.t('learning_unit_minute')}</span>
                              </div>
                            )
                            : (
                              <div className={clsx(styles.timeText)}>
                                <span className={clsx(styles.timeText_span0)}>{viewModel.totalLength.minutes}</span>
                                <span className={clsx(styles.timeText_span1)}>{i18n.t('learning_unit_minute')}</span>
                                <span className={clsx(styles.timeText_span2)}>{` ${viewModel.totalLength.seconds}`}</span>
                                <span className={clsx(styles.timeText_span3)}>{i18n.t('learning_unit_second')}</span>
                              </div>
                            )
                        }
                      </h1>
                      <div className={clsx(styles.timeDescription, styles.timeDescription_layout)}>
                        {i18n.t('course_info_duration')}
                      </div>
                    </div>
                  </div>
                  <div />
                </div>

                <div className={clsx(styles.purchaseBtnContainer, styles.purchaseBtnContainer_layout)}>
                  {
                    viewModel.isOwned || (viewModel.saleType !== 'Single' && (!!profile && profile?.group === 'Subscriber'))
                      ? (
                        <Link
                          to={`/course/${viewModel.id}/chapter`}
                          onClick={viewModel.onStartLearnClick}
                          className={clsx(styles.purchaseBtnContainer_item)}
                        >
                          <div className={clsx(styles.subscribeBtn, styles.subscribeBtn_layout)}>
                            <h3 className={clsx(styles.subtitle1, styles.subtitle1_layout)}>
                              {i18n.t('course_start_learn')}
                            </h3>
                          </div>
                        </Link>
                      )
                      : (
                        <>
                          {
                            viewModel.saleType !== 'Single'
                              ? (
                                <>
                                  <div
                                    className={clsx(styles.purchaseBtnContainer_item, styles.borderTypeBtn)}
                                    onClick={viewModel.purchaseModalVm.handlerOpenAlert}
                                  >
                                    <h5 className={clsx(styles.purchaseBtn_box, styles.purchaseBtn_box_layout)}>
                                      <pre className={clsx(styles.purchaseBtn)}>{i18n.t('course_purchase')}</pre>
                                    </h5>
                                  </div>
                                  <div className={clsx(styles.purchaseBtnContainer_spacer)} />
                                  <Link
                                    to="/subscription"
                                    className={clsx(styles.purchaseBtnContainer_item)}
                                  >
                                    <div className={clsx(styles.subscribeBtn, styles.subscribeBtn_layout)}>
                                      <h3 className={clsx(styles.subtitle1, styles.subtitle1_layout)}>
                                        {
                                          (!!profile && profile.group === 'ExpiredSubscriber') ? i18n.t('course_sub') : i18n.t('course_free')
                                        }
                                      </h3>
                                    </div>
                                  </Link>
                                </>
                              )
                              : (
                                <div
                                  className={clsx(styles.purchaseBtnContainer_item)}
                                  onClick={viewModel.purchaseModalVm.handlerOpenAlert}
                                >
                                  <div className={clsx(styles.subscribeBtn, styles.subscribeBtn_layout)}>
                                    <h3 className={clsx(styles.subtitle1, styles.subtitle1_layout)}>
                                      {i18n.t('course_purchase')}
                                    </h3>
                                  </div>
                                </div>
                              )
                          }
                        </>
                      )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${clsx('mainContent', styles.mainContentContainer, styles.mainContentContainer_layout)} main-flex`}>
          {
            viewModel.name && (
              <div className={clsx(styles.cookies, styles.cookies_layout)}>
                <Link to="/" className={clsx(styles.routeText, styles.textHover)}>{i18n.t('menu_home')}</Link>
                <div className={clsx(styles.routeText, styles.routeSpacer)}>/</div>
                {
                  !bread
                    ? (
                      <>
                        <Link
                          to={{
                            pathname: `/list/${viewModel.lowerType}`,
                            search: `?${createSearchParams({ filter: 'all', sort: 'Date' })}`
                          }}
                          className={clsx(styles.routeText, styles.textHover)}
                        >
                          {viewModel.TypeCT}
                        </Link>
                        <div className={clsx(styles.routeText, styles.routeSpacer)}>/</div>
                        <Link
                          to={{
                            pathname: `/list/${viewModel.lowerType}`,
                            search: `?${createSearchParams({ filter: viewModel.category?.id, sort: 'Date' })}`
                          }}
                          className={clsx(styles.routeText, styles.textHover)}
                        >
                          {viewModel.category?.name}
                        </Link>
                      </>
                    )
                    : (
                      <>
                        <Link
                          to={{
                            pathname: `/bookList/${bread[0].id}`
                          }}
                          className={clsx(styles.routeText, styles.textHover)}
                        >
                          {bread[0].name}
                        </Link>
                        <div className={clsx(styles.routeText, styles.routeSpacer)}>/</div>
                        <Link
                          to={{
                            pathname: `/bookList/${bread[0].id}`,
                            search: `?${createSearchParams({ list: bread[1].id })}`
                          }}
                          className={clsx(styles.routeText, styles.textHover)}
                        >
                          {bread[1].name}
                        </Link>
                      </>
                    )
                }

                <div className={clsx(styles.routeText, styles.routeSpacer)}>/</div>
                <div className={clsx(styles.routeText, styles.routerLast)}>
                  {viewModel.name}
                </div>
              </div>
            )
          }

          <div className={clsx(styles.mainThumbnail, styles.mainThumbnail_layout)}>
            <div className={clsx(styles.thumbnailContainer, styles.thumbnailContainer_layout)}>
              <div className={clsx(styles.thumbnailFlex, styles.thumbnailFlex_layout)}>
                {
                  viewModel.type === 'Video' && (
                    <div className={clsx(styles.thumbnailFlex_item)}>
                      <figure className={clsx(styles.imgContainerVideo, styles.imgContainerVideo_layout)}>
                        <img
                          src={viewModel.thumbnail}
                          alt={viewModel.name}
                          className={clsx(styles.thumbnailVideo, styles.thumbnailVideo_layout)}
                        />
                      </figure>
                      <div
                        className={styles.favIconContainer}
                        onClick={() => viewModel.changeIsFavorite(profile?.id)}
                      >
                        <img src={viewModel.isFavorite ? favIcon : unfavIcon} alt="fav" className={styles.favIcon} />
                      </div>
                    </div>
                  )
                }
                {
                  viewModel.type === 'Audio' && (
                    <div className={clsx(styles.thumbnailFlex_item1)}>
                      <figure className={clsx(styles.imgContainerAudio, styles.imgContainerAudio_layout)}>
                        <div style={{ '--src': `url(${disk})` }} className={clsx(styles.disk, styles.disk_layout)} />
                        <img
                          src={viewModel.thumbnail}
                          alt={viewModel.name}
                          className={clsx(styles.thumbnailAudio, styles.thumbnailAudio_layout)}
                        />
                      </figure>
                      <div
                        className={styles.favIconContainer}
                        onClick={() => viewModel.changeIsFavorite(profile?.id)}
                      >
                        <img src={viewModel.isFavorite ? favIcon : unfavIcon} alt="fav" className={styles.favIcon} />
                      </div>
                    </div>
                  )
                }
                {
                  viewModel.type === 'Audiobook' && (
                    <div className={clsx(styles.thumbnailFlex_item2)}>
                      <figure className={clsx(styles.imgContainer, styles.imgContainer_layout)}>
                        <img
                          src={viewModel.thumbnail}
                          alt={viewModel.name}
                          className={clsx(styles.thumbnailAudiobook, styles.thumbnailAudiobook_layout)}
                        />
                      </figure>
                      <div
                        className={styles.favIconContainer}
                        onClick={() => viewModel.changeIsFavorite(profile?.id)}
                      >
                        <img src={viewModel.isFavorite ? favIcon : unfavIcon} alt="fav" className={styles.favIcon} />
                      </div>
                    </div>
                  )
                }
                <div className={clsx(styles.thumbnailFlex_item3)}>
                  <div className={clsx(styles.tinyMainCard, styles.tinyMainCard_layout)}>
                    <div className={clsx(styles.tinyContainer, styles.tinyContainer_layout)}>
                      <h1 className={clsx(styles.tinyCourseTitle, styles.tinyCourseTitle_layout)}>
                        {viewModel.name}
                      </h1>
                      <h3 className={clsx(styles.tinyCourseSubtitle, styles.tinyCourseSubtitle_layout)}>
                        {viewModel.subtitle}
                      </h3>

                      <div className={clsx(styles.tagsFlex, styles.tagsFlex_layout)}>
                        <Link
                          to={{
                            pathname: `/list/${viewModel.lowerType}`,
                            search: `?${createSearchParams({ filter: viewModel.category?.id, sort: 'Date' })}`
                          }}
                          className={clsx(styles.categoryContainer, styles.categoryContainer_layout)}
                        >
                          <h5 className={clsx(styles.categoryText, styles.categoryText_layout)}>
                            {viewModel.category?.name}
                          </h5>
                        </Link>
                        <h5 className={clsx(styles.tagsContainer_box, styles.tagsContainer_box_layout)}>
                          <pre className={clsx(styles.tagsContainer)}>
                            {
                              viewModel.tags?.map((tag) => <span key={tag.id} className={styles.tag}>{`#${tag.name} `}</span>)
                            }
                          </pre>
                        </h5>
                      </div>

                      {
                        viewModel.discountRemain && (
                          <div className={clsx(styles.discountContainer, styles.discountContainer_layout)}>
                            <div className={clsx(styles.discountContainer_item)}>
                              <div style={{ '--src': `url(${clockOutline})` }} className={clsx(styles.clockIcon, styles.clockIcon_layout)}>
                                <div style={{ '--src': `url(${clockPin})` }} className={clsx(styles.pinIcon, styles.pinIcon_layout)} />
                              </div>
                            </div>
                            <h5 className={clsx(styles.discountText, styles.discountText_layout)}>
                              {viewModel.discountRemain}
                            </h5>
                          </div>
                        )
                      }

                      <div className={clsx(styles.priceContainer, styles.priceContainer_layout)}>
                        {
                          viewModel.discountRemain && (
                            <h5 className={clsx(styles.tinyOriginPrice, styles.tinyOriginPrice_layout)}>
                              {`${i18n.t('course_origin_price')}${viewModel.price ?? ''}${i18n.t('profile_my_point_left_unit')}`}
                            </h5>
                          )
                        }
                        <h1 className={clsx(styles.tinyFinalPrice, styles.tinyFinalPrice_layout)}>
                          {`${viewModel.discountRemain ? viewModel.price - viewModel.discount.price : viewModel.price ?? ''}${i18n.t('profile_my_point_left_unit')}`}
                        </h1>
                      </div>

                      <div className={clsx(styles.otherInfoRow, styles.otherInfoRow_layout)}>
                        <div />
                        <div
                          className={clsx(styles.infoFlex_item)}
                        >
                          {
                            ratingCount >= 10
                              ? (
                                <div
                                  className={clsx(styles.scoreContainer, styles.scoreContainer_layout)}
                                  onClick={viewModel.onRatingClick}
                                >
                                  <h1 className={clsx(styles.scoreText, styles.scoreText_layout)}>
                                    {viewModel.scoreText}
                                  </h1>
                                  <div className={clsx(styles.scoreStars, styles.scoreStars_layout)}>
                                    <RatingImg stars={viewModel.roundRating} size={12} disabled />
                                  </div>
                                </div>
                              )
                              : (
                                <div onClick={viewModel.onRatingClick}>
                                  <h1 className={clsx(styles.scoreNot)}>
                                    {i18n.t('rating_nobody_score_course_tiny')}
                                  </h1>
                                  <div className={clsx(styles.scoreStars, styles.scoreStars_layout)}>
                                    <RatingImg stars={0} size={12} disabled />
                                  </div>
                                </div>
                              )
                          }

                        </div>
                        <div className={clsx(styles.infoFlex_item1)}>
                          <div className={clsx(styles.box10, styles.box10_layout)} />
                        </div>
                        <div className={clsx(styles.infoFlex_item2)}>
                          <div className={clsx(styles.viewedContainer, styles.viewedContainer_layout)}>
                            <h1 className={clsx(styles.viewedText_box, styles.viewedText_box_layout)}>
                              {
                                viewModel.tenThousands
                                  ? (
                                    <div className={clsx(styles.viewedText)}>
                                      <span className={clsx(styles.viewedText_span0)}>{`${viewModel.tenThousands.upper}.${viewModel.tenThousands.lower}`}</span>
                                      <span className={clsx(styles.viewedText_span1)}>萬</span>
                                    </div>
                                  )
                                  : (
                                    <div className={clsx(styles.viewedText)}>
                                      <span className={clsx(styles.viewedText_span0)}>{viewModel.popularity}</span>
                                    </div>
                                  )
                              }
                            </h1>
                            <div className={clsx(styles.viewedDescription, styles.viewedDescription_layout)}>
                              {i18n.t('course_info_viewed')}
                            </div>
                          </div>
                        </div>
                        <div className={clsx(styles.infoFlex_item3)}>
                          <div className={clsx(styles.box10, styles.box10_layout)} />
                        </div>
                        <div className={clsx(styles.infoFlex_item4)}>
                          <div className={clsx(styles.timeContainer, styles.timeContainer_layout)}>
                            <h1 className={clsx(styles.timeText_box, styles.timeText_box_layout)}>
                              {
                                viewModel.totalLength.hours
                                  ? (
                                    <div className={clsx(styles.timeText)}>
                                      <span className={clsx(styles.timeText_span0)}>{viewModel.totalLength.hours}</span>
                                      <span className={clsx(styles.timeText_span1)}>{i18n.t('learning_unit_hour')}</span>
                                      <span className={clsx(styles.timeText_span2)}>{` ${viewModel.totalLength.minutes}`}</span>
                                      <span className={clsx(styles.timeText_span3)}>{i18n.t('learning_unit_minute')}</span>
                                    </div>
                                  )
                                  : (
                                    <div className={clsx(styles.timeText)}>
                                      <span className={clsx(styles.timeText_span0)}>{viewModel.totalLength.minutes}</span>
                                      <span className={clsx(styles.timeText_span1)}>{i18n.t('learning_unit_minute')}</span>
                                      <span className={clsx(styles.timeText_span2)}>{` ${viewModel.totalLength.seconds}`}</span>
                                      <span className={clsx(styles.timeText_span3)}>{i18n.t('learning_unit_second')}</span>
                                    </div>
                                  )
                              }
                            </h1>
                            <div className={clsx(styles.timeDescription, styles.timeDescription_layout)}>
                              {i18n.t('course_info_duration')}
                            </div>
                          </div>
                        </div>
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PurchaseModal
          viewModel={viewModel.purchaseModalVm}
          notice={viewModel.notice}
          profile={profile}
          cid={viewModel.id}
        />
      </>
    );
  }
}

MainCard.propTypes = {
  viewModel: PropTypes.object,
  profile: PropTypes.object,
  ratingCount: PropTypes.number,
  bread: PropTypes.array
};

MainCard.defaultProps = {
  viewModel: {},
  profile: {},
  ratingCount: 0,
  bread: null
};

export default withProfile(MainCard, false);
